<template>
  <div class="quiz-container">
    <div ref="herowrapper" class="herowrapper">
      <img src="@/assets/img/female.png"/>
      <img src="@/assets/img/male.png"/>
    </div>

    <p class="quiz-question">
      <strong class="quiz-question__intro" v-if="(this.quizIntroData)">
        {{ this.quizIntroData }}
      </strong>

      {{ quizData.questions[0].question }}
      <img src="@/assets/img/quiz.png"/>
    </p>
    <div class="quiz-answers" :class="quizData.size">
      <template v-for="(answer, index) in quizData.questions[0].answers" :key="index">
        <span @click="selectAnswer(answer, index)" :class="getClass(answer, index)" class="quiz-option">
          <span class="quiz-option_checkbox"><span class="quiz-option_checkbox_border">
            <svg fill="#000000" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg"
                 xmlns:xlink="http://www.w3.org/1999/xlink"
                 width="800px" height="800px" viewBox="0 0 335.765 335.765"
                 xml:space="preserve">
<g>
	<g>
		<polygon points="311.757,41.803 107.573,245.96 23.986,162.364 0,186.393 107.573,293.962 335.765,65.795 		"/>
	</g>
</g>
</svg>
          </span>
          </span>
          <span class="quiz-option_text">
            {{ answer.text }}
          </span>
        </span>
      </template>

    </div>
    <transition-group>
      <div class="quiz-feedback" :class="feedbackBool" v-if="feedback">
        <p>{{ feedback }}</p>
      </div>
      <div ref="quizExplanation" v-if="feedback" class="quiz-explanation">
        <span>{{ quizData.explanation }}</span>
      </div>
    </transition-group>
  </div>
</template>

<script>
import {gsap} from "gsap";
import {ScrollToPlugin} from 'gsap/ScrollToPlugin'

gsap.registerPlugin(ScrollToPlugin)

export default {
  name: 'QuizComponent',
  props: {
    quizData: {
      type: Object,
      required: true
    },
    quizIntroData: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      selectedAnswerIndex: null,
      feedback: null,
      feedbackBool: null,
      correctAnswerIndex: null // Füge diese Zeile hinzu
    };
  },
  mounted() {
    // Finde den Index der richtigen Antwort beim Initialisieren
    this.correctAnswerIndex = this.quizData.questions[0].answers.findIndex(answer => answer.isCorrect);
    this.$nextTick(() => {
      this.initAnimation();
    });


  },
  methods: {
    initAnimation() {
      const images = this.$refs.herowrapper.querySelectorAll('img');

      // GSAP Animation mit Stagger-Effekt
      gsap.from(images, {
        autoAlpha: 0,
        y: -50, // Optional: bewegt die Bilder 50px von unten nach oben
        stagger: 0.2, // Zeitverzögerung zwischen den Animationen der einzelnen Bilder
        duration: 1, // Dauer der Animation für jedes Bild
        delay: 2
      });
    },
    selectAnswer(answer, index) {
      this.feedback = null;
      this.selectedAnswerIndex = index;
      this.feedbackBool = answer.isCorrect ? 'feedback_correct' : 'feedback_wrong';
      setTimeout(() => {
            this.feedback = answer.isCorrect ? this.$t('general.correct') : this.$t('general.wrong');
            this.$nextTick(() => {
              this.scrollToElement();
            });
          }, 600
      )


    },
    getClass(answer, index) {
      // Markiere die richtige Antwort, wenn eine falsche ausgewählt wird
      // if (index === this.correctAnswerIndex && this.selectedAnswerIndex !== null && !this.quizData.questions[0].answers[this.selectedAnswerIndex].isCorrect) {
      //   return 'clicked_correct';
      // }


      // Markiere die ausgewählte Antwort
      if (index === this.selectedAnswerIndex) {
        return answer.isCorrect ? 'clicked_correct' : 'clicked_wrong';
      }
      return '';
    },
    scrollToElement() {
      const element = this.$refs.quizExplanation;
      const rect = element.getBoundingClientRect();
      const isVisible = (
          rect.top >= 0 &&
          rect.left >= 0 &&
          rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
          rect.right <= (window.innerWidth || document.documentElement.clientWidth)
      );
      if (!isVisible) {
        gsap.to((".popup_wrapper.hasQuiz"), {
          scrollTo: {y: element, autoKill: true},
          duration: 1.5
        });
      }
    }
  }
};
</script>

<style scoped lang="scss">
.v-enter-active,
.v-leave-active {
  transition: opacity 0.5s ease;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
}

.quiz-container {
  margin-top: 90px;
  position: relative;
  width:100%;

  h2 {
    font-weight: 600;
    margin-bottom: 5px;
    font-size: 28px;
  }

  @media screen and (max-width: 1024px) {
    margin-top: 40px;
  }

}


.herowrapper {
  z-index: 2;
  position: absolute;
  top: 0px;
  left: 35px;
  transform: translateY(-50%);
  @media screen and (max-width: 480px) {
    left: 15px;
  }
  img {
    pointer-events: none;
    width: 90px;
    @media screen and (max-width:480px) {
      width:70px;
    }

    &:first-of-type {
      transform: translateX(0%);
    }
    &:last-of-type {
      transform: translateX(-15%);
    }
  }
}

.quiz-question {
  background: #015672;
  border-radius: 20px;
  padding: 60px 80px 35px 35px;
  margin: 0px;
  font-size: 22px;
  position: relative;
  color: #fff;

  @media screen and (max-width: 1366px) {
    padding: 60px 35px 35px;
  }
  @media screen and (max-width: 768px) {
    font-size: 16px;
    line-height: 1.4em;
  }
  @media screen and (max-width: 480px) {
    padding:65px 15px 15px;
  }

  img {
    position: absolute;
    right: 15px;
    top: 0px;
    transform: translateY(-50%);
    width: 105px;
  }
}

.quiz-answers {
  margin-top: 15px;
  display: grid;
  //grid-template-columns: repeat(2, 1fr);
  grid-template-columns: repeat(auto-fill, minmax(calc(50% - 7.5px), 1fr));
  grid-gap: 15px;
  grid-auto-rows: 1fr;
  @media screen and (max-width:640px) {
    grid-template-columns: repeat(1, 1fr);
  }

  &.big {
    grid-template-columns: repeat(1, 1fr);
  }
}

.quiz-option_checkbox_border {
  svg {
    display: none;
    position: absolute;
    top: 50%;
    left: 0px;
    width: 25px;
    height: auto;
    z-index: 999;
    /* fill: green; */
    /* color: green; */
    transform: translate3d(2px, -60%, 0px);
    fill: #FDBE1F !important;

    g {
      fill: #FDBE1F !important;
    }
  }
}

.quiz-option {
  display: flex;
  font-size: 20px;
  background: #F5F5F5;
  box-sizing: border-box;
  border-radius: 10px;
  padding: 15px;
  flex: 0 0 calc(50% - 7.5px);
  text-align: center;
  justify-content: center;
  position: relative;
  transition: 0.5s;

  @media screen and (max-width: 480px) {
    flex: 0 0 100%;
  }

  &:hover {
    cursor: pointer;
  }

  &.clicked_correct {
    background: #015672;

    .quiz-option_text {
      color: #fff;
    }

    .quiz-option_checkbox {
      .quiz-option_checkbox_border {
        border-color: #fff;
        background: #015672;

        svg {
          display: block;
        }
      }
    }
  }

  &.clicked_wrong {
    background: #d4d4d4;

    .quiz-option_text {

    }

    .quiz-option_checkbox {
      .quiz-option_checkbox_border {
        border-color: #3f1621;
        background: #3f1621;

        &:before {
          border-radius: 0%;
          position: absolute;
          display: block;
          content: '';
          border: 0px solid #fff;
          height: 100%;
          width: 100%;
          box-sizing: border-box;
          -moz-box-sizing: border-box;
          -webkit-box-sizing: border-box;
          background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="%23fff" class="bi bi-x" viewBox="0 0 16 16"><path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708"/></svg>') no-repeat center center;
          background-size: 100%;
        }
      }
    }
  }
}


.quiz-option .quiz-option_text {
  color: #333;
  padding: 0 30px 0 40px;
  font-size: 18px;
  text-align: center;
  line-height: 1.2em;
  align-items: center;
  justify-content: center;
  display: inline-flex;
  transform: translateY(1.25px);
}

.quiz-option .quiz-option_checkbox {
  position: absolute;
  left: 15px;
  top: 50%;
  width: 20px;
  height: 20px;
  transform: translateY(-50%);

  .quiz-option_checkbox_border {
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background: #fff;
    border: 2px solid #015672;
    position: relative;
    display: block;
  }
}

.quiz-feedback {
  margin-top: 30px;
  padding: 5px 10px;
  background: #d4d4d4;
  display: inline-block;
  font-size: 18px;
  border-radius: 10px;
  margin-bottom: 10px;

  &.feedback_correct {
    background: #015672;
    color: #fff;
  }
}

.quiz-explanation {
  font-size: 22px;
  @media screen and (max-width:768px) {
    font-size:16px;
  }
}

/* Zusätzliche Stile für den Feedback-Bereich */
.quiz-feedback p:first-child {
}
.quiz-question__intro{
  display:block; font-weight:700;
}
</style>
